import { useTranslation } from "react-i18next";
import { ChangeLanguage } from "../changeLanguage";
import { query } from "@/utils";
import "./header.scss";

export const Header = () => {
  const { t } = useTranslation();
  const userName = query("userName");

  return (
    <div className="header-container">
      <div className="header-list">
        <div className="header-user-name">{userName}</div>
        <div className="header-item">{t("邀请您加入聊天")}</div>
      </div>
      <ChangeLanguage />
      {/* <div className="change-language">
        <span onClick={changeLanguage}>{language}</span>
        {showHelpModal && (
          <div className="select-lists">
            {langSelects.map((item) => {
              return (
                <div
                  key={item.label}
                  onClick={() => itemHandler(item)}
                  className="select-item"
                >
                  {t(item.label)}
                </div>
              );
            })}
          </div>
        )}
      </div> */}
    </div>
  );
};
